import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { WebSocketSubject } from 'rxjs/webSocket';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth/auth-service';
import { WsMessage } from '../models/web-socket-message';
import { Token } from '../models/token';

@Injectable()
export class WebsocketService implements OnDestroy {
  public connection?: WebSocketSubject<any>;
  public messageReceived$ = new EventEmitter<WsMessage>();

  constructor(private readonly authService: AuthService) {}

  public connect(): Observable<any> {
    if (this.connection) {
      return this.connection;
    }
    this.connection = new WebSocketSubject({
      url: environment.WS_URL + '/backend/ws/user-updates-stream/',
      openObserver: {
        next: async () => {
          let jwt = localStorage.getItem(Token.tokenNameInStorage);
          if (jwt) {
            jwt = jwt.replace('Bearer ', '');
            await this.send({
              type: 'authenticate',
              jwt: jwt
            });
          }
        }
      },
      closeObserver: {
        next: () => {
          console.warn('WebSocket connection closed!');
        }
      }
    });
    this.connection.subscribe({
      next: (message: WsMessage) => {
        this.messageReceived(message);
      },
      error: (error) => {
        console.error('WebSocket connection error:', error);
        throw error;
      },
      complete: () => {
        return;
      }
    });

    return this.connection;
  }

  public async send(data: any) {
    const tokenJWT = localStorage.getItem(Token.tokenNameInStorage);
    if (this.connection) {
      this.connection.next({
        token: tokenJWT,
        ...data
      });
    }
  }

  public messageReceived(message: WsMessage) {
    this.messageReceived$.emit(message);
  }

  public closeConnection() {
    if (this.connection) {
      this.connection.complete();
      this.connection = undefined;
    }
  }

  public ngOnDestroy() {
    this.closeConnection();
  }
}
